var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"cfbg mt-8",attrs:{"dark":"","flat":"","dense":""}},[_c('div',[_vm._v(" Research and Development by Alessandro Mantelli (2020-) - Department of Asian and North African Studies - Ca' Foscari University of Venice ")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }